var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetInvite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4119 9.21696C26.6788 9.22259 26.9469 9.24571 27.2119 9.27446C29.1863 9.48634 31.1475 9.99509 32.89 10.947C33.9188 11.5095 34.8844 12.2432 35.5138 13.2326C36.13 14.2007 36.3763 15.4157 36.0113 16.5201C35.6525 17.6045 35.0069 18.4957 34.12 19.2145C34.0669 19.257 34.0138 19.2995 33.96 19.3407C33.0413 20.0438 31.9838 20.5388 30.9288 21.0138C29.9863 21.4382 29.0294 21.8545 28.0163 22.0613C27.0032 22.2688 25.9188 22.2551 24.9713 21.8407C23.33 21.122 22.3944 19.3401 22.0432 17.5832C21.7113 15.9251 21.7925 14.1788 22.3325 12.5763C22.8194 11.1313 23.8088 9.71446 25.2844 9.33071C25.6519 9.23509 26.0307 9.20884 26.4119 9.21696Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3556 8.32572C25.7888 7.43259 22.1738 9.60009 21.2813 13.167C21.2806 13.1688 21.28 13.1713 21.2794 13.1732C20.2369 17.3782 21.6131 20.1226 26.135 21.2413C30.6569 22.3601 33.1356 20.607 34.2031 16.3938C35.0881 12.8276 32.9194 9.21822 29.3544 8.32634L29.3556 8.32572Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2031 20.7095C32.2031 20.7095 36.5025 26.0345 37.5281 26.9626",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69495 10.863L15.2362 11.9599",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.3793L13.0962 18.5068",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45813 25.4775L15.2438 25.3794",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75378 31.3938L29.5407 31.2957",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetInvite);
export default __webpack_public_path__ + "static/media/vet-invite.1432b6d6bba3f861908c90c9400d3b55.svg";
export { ForwardRef as ReactComponent };